import {
  Grid,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { PageHeader } from "../../../../components/PageHeader";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type KeywordToBeComparedProps = {
  clusters: any;
  variant?: string;
  side?: "left" | "right" | string;
  width?: number;
  chosenCluster?: any;
  changeClusterAction?: any;
};

export function KeywordCompareComponent(props: KeywordToBeComparedProps) {
  // const [chosenCluster, setChosenCluster] = useState(null);
  const { t } = useTranslation(["common", "keyword"]);
  var clusterOptions = <div></div>;
  console.log(props);
  if (props.clusters && props.clusters.length > 0) {
    clusterOptions = props.clusters.map((cluster: any) => {
      return <MenuItem value={cluster.id}>{cluster.name}</MenuItem>;
    });
  }

  console.log(props.chosenCluster.name)
  useEffect(() => {}, [props.chosenCluster]);

  var color = props.variant == "against" ? "pink" : "blue";
  return (
    <Grid item xs={props.width} sx={{ padding: "10px" }}>
      <Grid
        item
        sx={{
          borderStyle: "solid",
          borderColor: color,
        }}
      >
        <Select
          label={t("common:Type_of_feedback")}
          variant="standard"
          value={props.chosenCluster ? props.chosenCluster.name : ""}
          fullWidth
          sx={{ textAlign: "left" }}
          onChange={(event: SelectChangeEvent) => {
            props.changeClusterAction(event.target.value);
          }}
        >
          {clusterOptions}
        </Select>
        <Typography>{"A"}</Typography>
      </Grid>
    </Grid>
  );
}
